import React from 'react';
import { BoneIcon, FlameIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerItems } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-134" data-mp="mejsg5kmk7pc">
      <p className="font-heading text-[11px] font-bold uppercase tracking-[0.3em] text-goldDark md:text-[12px]" data-id="element-135" data-mp="re662g4d7pyo">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[512px] rounded-lg border-2 border-gold bg-surface px-3 pb-4 pt-3 md:px-4" data-id="element-136" data-mp="wchhgvab68j0">
        <h2 className="font-heading text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-navy md:text-[28px]" data-id="element-137" data-mp="2t7dymr8zo42i">
          <BoneIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-brand" strokeWidth={2.5} aria-hidden data-id="element-138" data-mp="12o1ur0x94y6z" />
          Complete Orthopedic &amp; Trauma Toolkit™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-[1.35] text-brand md:text-[12px]" data-id="element-139" data-mp="xuz16ssh5oqs">
          The complete professional resource collection for orthopedic surgeons and trauma specialists.
        </p>

        <div className="mx-auto mt-2.5 max-w-[220px]" data-id="element-140" data-mp="1ll338vq0lgfo">
          <ProductImage data-id="element-141" data-mp="1gnjbqu4b375s" />
        </div>

        <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-navy md:text-[14px]" data-id="element-142" data-mp="1gol183m2jw71">
          The complete 6-in-1 clinical system
        </p>
        <p className="mt-0.5 text-[13px] text-ink md:text-[14px]" data-id="element-143" data-mp="17mv7us8mmn6m">Your purchase includes:</p>
        <ul className="mx-auto mt-1.5 max-w-[400px] text-left text-[14px] leading-[1.5] text-ink md:text-[15px]" data-id="element-144" data-mp="16j4mcqy6f46">
          {offerItems.map(item => <CheckItem key={item} data-id="element-145" data-mp="3sb99ketzvovj">{item}</CheckItem>)}
        </ul>
        <p className="mt-2 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-146" data-mp="3tv13keiyz36g">
          440 pages across 11 digital resources
        </p>

        <p className="mt-3 flex items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[16px]" data-id="element-147" data-mp="3ktbaz5dcpy73">
          <FlameIcon className="h-4 w-4 shrink-0 fill-flameFill text-flame" strokeWidth={2} aria-hidden data-id="element-148" data-mp="3ot3db0c5j840" />
          Get the complete toolkit today!
        </p>
        <p className="mt-1 font-heading text-[14px] font-extrabold uppercase text-navy" data-id="element-149" data-mp="3fuhyng9swd8i">Only</p>
        <p className="font-heading text-[46px] font-extrabold leading-none tracking-[-1px] text-gold md:text-[54px]" data-id="element-150" data-mp="315u51fjimdl7">
          {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-navy md:text-[20px]" data-id="element-151" data-mp="364omoe5qxw3q">USD</span>
        </p>

        <div className="mt-2.5" data-id="element-152" data-mp="2s6qn4ew3448a">
          <CtaButton mode="checkout" className="max-w-none min-h-[64px]" data-id="element-153" data-mp="2x3h0uvkf2nqj">
            Get instant access
          </CtaButton>
        </div>

        <p className="mx-auto mt-2.5 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-snug text-navy md:text-[12px]" data-id="element-154" data-mp="2diqavnqet8yn">
          {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-155" data-mp="2mivhvwroy5ca" />}
          Instant digital delivery
          {guaranteeEnabled && <>
              {' '}
              <span className="text-gold" data-id="element-156" data-mp="2wfi0eewjokb5">•</span> 7-day money-back guarantee
            </>}
        </p>
        <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-157" data-mp="2rh6ozzqlq1qt">
          6 Advanced Volumes + 5 FREE Professional Bonuses
        </p>
      </div>
    </section>;
}